export const variables = {
  appId: '48649115-6eb0-446c-99e7-5a2c479e86ff',
  b2cBaseUrl: 'https://ivchealth01.b2clogin.com/ivchealth01.onmicrosoft.com/',
  scope: 'https://alg-uat-sa-terra-app-environment-api-01.azurewebsites.net',
  androidRedirectUrl: 'msauth://health.bic.ivchealth/2jmj7l5rSw0yVb%2FvlWAYkK%2FYBwk%3D',
  iosRedirectUrl: 'msauth.health.bic.ivchealth://auth',
};
import { IFrontendEnvironment } from '../frontend-environment.interface';

export const environment: IFrontendEnvironment = {
  environmentName: 'allegra-staging-rsa',
  production: false,
  mapProviders: ['Leaflet'],
  appEnvironmentBaseUrl: 'https://alg-uat-sa-terra-app-environment-api-01.azurewebsites.net',
  availablelanguages: [{ code: 'en', text: 'English', dir: 'ltr', fontFamily: 'ApaxThree' }],
  DefaultLobbyID: '',
  multipleDiaries: {
    enabled: false,
  },
  otpVerification: {
    enabled: false,
  },
  bookingFeatures: {
    enableMinorDetails: true,
    enableIdCapture: true,
  },
  canaryTokenScripts: [],
  mapsConfig: {
    baseUrl: 'https://uat-api.allegra.health',
    tileStyle: 'liberty',
    subscriptionKey: '51550fafb61844d79f7e1ee60abfd90c',
  },
};
